// extracted by mini-css-extract-plugin
export default {"benefit-item":"styles-module_benefit-item---x1qK_","benefit-image":"styles-module_benefit-image---Emzio"};